<h2 mat-dialog-title>
  {{
    "customerSelection.title." +
      (multi ? "multi." : "single.") +
      ((isFamily$ | async) === true ? "people" : "customers") | translate
  }}
</h2>
<mat-dialog-content>
  <ca-customer-selection-view
    paginationId="customerSelectDialogComponent"
    [hideUnassigned]="hideUnassigned"
    [selectedIds]="selectedIds"
    [selectedCustomerListIds]="selectedCustomerListIds"
    [disableNoMedia]="disableNoMedia"
    [disableWhereFamilyRole]="disableWhereFamilyRole"
    (customerSelected)="toggle($event)"
    (customerListSelected)="toggleCustomerList($event)"
    [initialTab]="data.initialTab"
    [multiple]="multi"
    [adminRoute]="adminRoute"
  >
    >
  </ca-customer-selection-view>
</mat-dialog-content>

<mat-dialog-actions class="flex flex-row-reverse align-end items-baseline">
  @if (selectedIds | customersFromIds | async; as selectedCustomerEntities) {
    <button ca-action-button (click)="submitAndClose(selectedCustomerEntities)">
      {{ "done" | translate }}
    </button>
  }

  @if (multi) {
    <mat-accordion class="flex justify-start w-11/12">
      <mat-expansion-panel
        class="mat-elevation-z0"
        [expanded]="selectedIdPanelOpenState"
        (opened)="selectedIdPanelOpenState = true"
        (closed)="selectedIdPanelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <p class="panelTitle">
              {{
                "customerSelection.selectedCount." +
                  ((isFamily$ | async) === true ? "people" : "customers")
                  | translate: { count: selectedIds.length }
              }}
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-chip-listbox
          [aria-label]="
            (isFamily$ | async) === true
              ? 'Selected People'
              : 'Selected Customers'
          "
          [multiple]="false"
          class="chipSelection"
        >
          @for (
            customer of selectedIds
              | customersFromIds
              | async
              | filter
                : customerFilter(
                    disableNoMedia ? true : null,
                    disableWhereFamilyRole ? true : null
                  );
            track customer
          ) {
            <mat-chip-option
              class="selectedCustomerChip"
              color="secondary"
              (click)="toggle(customer)"
            >
              <ca-avatar
                matChipAvatar
                [chip]="true"
                [fullName]="customer | displayname"
                [image]="
                  customer.profileImage != null
                    ? (customer.profileImage
                      | filedownloadurl: 'sizeTiny'
                      | async)
                    : null
                "
                [blur]="
                  customer.profileImage != null
                    ? (customer.profileImage | mediaBlurUrl)
                    : null
                "
              >
              </ca-avatar>
              {{ customer | displayname }}
              <mat-icon matChipRemove>close</mat-icon>
            </mat-chip-option>
          }
        </mat-chip-listbox>
        @if (disableNoMedia) {
          <mat-chip-listbox
            [aria-label]="
              (isFamily$ | async) === true
                ? 'Selected people without media enabled'
                : 'Selected customers without media enabled'
            "
            [multiple]="false"
          >
            @for (
              customer of selectedIds
                | customersFromIds
                | async
                | filter: customerFilter(false);
              track customer
            ) {
              <mat-chip-option
                class="selectedCustomerChipNoMedia"
                color="disabled"
                [matTooltip]="
                  'customerList.customerPhotosBlocked.noName' | translate
                "
                (click)="toggle(customer)"
              >
                <div class="selectedCustomerChipAvatar disabledChipAvatar">
                  <ca-avatar
                    [chip]="true"
                    [fullName]="customer | displayname"
                    [image]="
                      customer.profileImage != null
                        ? (customer.profileImage
                          | filedownloadurl: 'sizeTiny'
                          | async)
                        : null
                    "
                    [blur]="
                      customer.profileImage != null
                        ? (customer.profileImage | mediaBlurUrl)
                        : null
                    "
                  >
                  </ca-avatar>
                </div>
                <span class="noSelect">
                  {{ customer | displayname }}
                </span>
                <mat-icon>no_photography</mat-icon>
              </mat-chip-option>
            }
          </mat-chip-listbox>
        }
      </mat-expansion-panel>
    </mat-accordion>
  } @else {
    <!-- Invisible div to push the 'done' button to the right. -->
    <div class="w-11/12"></div>
  }
</mat-dialog-actions>
